import { Injectable ,Output, EventEmitter} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DecimalPipe, DatePipe } from '@angular/common';
import { Observable } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { SecurityService } from '../../Core/Security/security.service';
import { ConfigService } from '../../Core/Abstract/config.service';
import { LogService } from '../../Core/Abstract/log.service';

import { EventsEmitterService } from '../../Core/Abstract/emitter.service';
import { Router } from '@angular/router';
import * as moment from 'moment/moment';
import { GridService } from 'app/Core/Abstract/grid.service';
import { FormlyFieldConfig } from '@ngx-formly/core';
import * as FileSaver from 'file-saver';

@Injectable()

export class OnboardService extends SecurityService{
    @Output() change: EventEmitter<boolean> = new EventEmitter();
    constructor(http:HttpClient,configService:ConfigService,eventsEmitterService: EventsEmitterService, router:Router, logger:LogService, private datePipe:DatePipe) {
        super(http,configService,eventsEmitterService, router ,logger);
    }

    submit(bean:any): Observable<any>{
        let serviceUrl = this.baseUrl + 'OnBoardService/submit?langId=1';
        return this.http.post<any>(serviceUrl,bean).pipe(map(response => {return response;}));
    }

    save(formVal: Object ,id:number): Observable<any>{
        let form = {'dataChar' : JSON.stringify(formVal)}
        let serviceUrl = this.baseUrl + 'FormDataService/data?formCd=Onboarding_Main_Form&userId='+id;
        return this.http.post<any>(serviceUrl,form).pipe(map(response => {return response;}));
    }

    loadBean(userId): Observable<any>{
        let serviceUrl = this.baseUrl + 'FormDataService/data?formCd=Onboarding_Main_Form&userId='+userId;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    getClonedData(data, userId): Observable<any> {
        const url = this.baseUrl + 'FormDataService/copiedData?formCd=Onboarding_Main_Form&from=' + data.cloneId + '&to=' + userId + '&isCopyDocuments=' + data.isCopyDocuments;
        return this.http.get<any>(url).pipe(map(res => res));
    }

    getDocumentList(companyType:any , isAdmin: string,userId: any): Observable<any>{
        let serviceUrl = this.baseUrl + 'FileUploadService/getDocumentList?companyType='+companyType + '&isAdmin='+isAdmin + '&userId='+userId;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    getBankDetails(bankId): Observable<any>{
        let serviceUrl = this.baseUrl + 'OnBoardService/getLookupBanks?countryId=&bankName=&bankId='+bankId;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    getBankbyText(): Observable<any>{
        let serviceUrl = this.baseUrl + 'OnBoardService/getLookupBanks?countryId=&bankName=&bankId=';
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    getSwiftCodes(): Observable<any>{
        let serviceUrl = this.baseUrl + 'OnBoardService/getLookupSwiftCodes?countryId=&bankName=&bankId=&swiftcode=';
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    validationFromServer(){
        let serviceUrl = this.baseUrl + 'UtilService/getValidations';
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }
    getTerms(userId){
        let serviceUrl = this.baseUrl + 'OnBoardService/getTerms?userId='+userId;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    downloadTermsFile(userId: number, filename: string): Observable<any> {
        const extension = filename.split('.').pop();
        const serviceUrl = this.baseUrl + 'OnBoardService/getTermsDoc';
        return this.http.get(serviceUrl, {responseType: 'blob', params: {'userId': userId, 'extension': extension}})
            .pipe(map(res => {
                const blob = new Blob([res], {type: res.type});
                FileSaver.saveAs(blob, filename);
            }));
    }

    getBuyerCompany(regSecId){
        let serviceUrl = this.baseUrl + 'OnBoardService/getBuyerCompany?regSecId='+ regSecId;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    getStatus(userId){
        let serviceUrl = this.baseUrl + 'OnBoardService/getStatus?userId='+userId;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    getQuestions(userId,formname){
        let serviceUrl = this.baseUrl + 'FormService/formClientList?userId='+userId +'&formCd='+formname;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }

    submitClient(questionForm,submitType,userId): Observable<any>{
        let serviceUrl = this.baseUrl + 'OnBoardService/submitClientForm?submitType='+submitType+'&userId='+userId;
        return this.http.post<any>(serviceUrl,questionForm).pipe(map(response => {return response;}));
    }

    getIsMiddle(userId){
        let serviceUrl = this.baseUrl + 'UtilService/getIsMiddleUserStatus?userId='+userId;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));  
    }
    getFields(userId): Observable<any>{
        let serviceUrl = this.baseUrl+'FormDataService/configData?formCd=Onboarding_Main_Form&langId=2&userId='+userId;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }
    getTermsFields(userId): Observable<any>{
        let serviceUrl = this.baseUrl+'FormDataService/configData?formCd=Terms_Form&langId=2&userId='+userId;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }
    loadTermsBean(userId): Observable<any>{
        let serviceUrl = this.baseUrl + 'FormDataService/data?formCd=Terms_Form&userId='+userId;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }
    saveTerms(formVal: Object ,id:number): Observable<any>{
        let form = {'dataChar' : JSON.stringify(formVal)}
        let serviceUrl = this.baseUrl + 'FormDataService/data?formCd=Terms_Form&userId='+id;
        return this.http.post<any>(serviceUrl,form).pipe(map(response => {return response;}));
    }
    saveNewCompany(companyName){
        let name = companyName.cmpNm
        let serviceUrl = this.baseUrl + 'OnBoardService/createNewCompany?cmpNm='+name;
        return this.http.get<any>(serviceUrl).pipe(map(response => {return response;}));
    }
}
